"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCiToSeo = exports.hasDataAfterFacets = exports.getNumProducts = exports.getUnfilteredFacet = exports.getPageNumber = exports.getSort = exports.getDomain = exports.isPromoPage = exports.isSearchPage = exports.hasPageName = exports.hyphenToSpace = exports.SLASH_CHAR_REGEX = exports.DASH_CHAR_REGEX = exports.QUERY_PARAM_NUM_PRODUCTS = exports.UNFILTERED_FACET = exports.QUERY_PARAM_PAGE = exports.QUERY_PARAM_SORT = exports.DUMMY_DOMAIN = void 0;
/* eslint-disable no-useless-escape */
var types_1 = require("../Types/types");
exports.DUMMY_DOMAIN = 'http://mock-domain.com';
exports.QUERY_PARAM_SORT = 'sortkey';
var QUERY_PARAM_SORT_ENDECA = 'sort';
exports.QUERY_PARAM_PAGE = 'page';
exports.UNFILTERED_FACET = 'uf';
exports.QUERY_PARAM_NUM_PRODUCTS = 'numProducts';
exports.DASH_CHAR_REGEX = /-/g;
exports.SLASH_CHAR_REGEX = /\//g;
function hyphenToSpace(str) {
    return str.replace(exports.DASH_CHAR_REGEX, ' ');
}
exports.hyphenToSpace = hyphenToSpace;
function hasPageName(type) {
    return type === types_1.PageType.promo || type === types_1.PageType.valuedeal;
}
exports.hasPageName = hasPageName;
function isSearchPage(type) {
    return type === types_1.PageType.search;
}
exports.isSearchPage = isSearchPage;
function isPromoPage(type) {
    return type === types_1.PageType.promo;
}
exports.isPromoPage = isPromoPage;
function getDomain(url) {
    if (url.origin !== exports.DUMMY_DOMAIN) {
        return url.hostname;
    }
    return undefined;
}
exports.getDomain = getDomain;
function getSort(url) {
    return url.searchParams.get(exports.QUERY_PARAM_SORT) || url.searchParams.get(QUERY_PARAM_SORT_ENDECA) || undefined;
}
exports.getSort = getSort;
function getPageNumber(url) {
    return Number(url.searchParams.get(exports.QUERY_PARAM_PAGE)) || undefined;
}
exports.getPageNumber = getPageNumber;
function getUnfilteredFacet(url, _a) {
    var category = _a.category, facets = _a.facets, type = _a.type;
    var uf = url.searchParams.get(exports.UNFILTERED_FACET);
    if (typeof uf === 'string')
        return uf.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
    if (!(facets === null || facets === void 0 ? void 0 : facets.length) || (category === null || category === void 0 ? void 0 : category.id) || type !== types_1.PageType.browse)
        return;
    var singleValueFacet = facets.find(function (f) { var _a; return ((_a = f.values) === null || _a === void 0 ? void 0 : _a.length) === 1; });
    return singleValueFacet === null || singleValueFacet === void 0 ? void 0 : singleValueFacet.id;
}
exports.getUnfilteredFacet = getUnfilteredFacet;
function getNumProducts(url) {
    return Number(url.searchParams.get(exports.QUERY_PARAM_NUM_PRODUCTS)) || undefined;
}
exports.getNumProducts = getNumProducts;
function hasDataAfterFacets(type) {
    return hasPageName(type) || isSearchPage(type);
}
exports.hasDataAfterFacets = hasDataAfterFacets;
function transformCiToSeo(str, isRange) {
    if (isRange) {
        return str
            .replace(/\"/g, '')
            .replace(/^-inf-([\d\.]+)/, 'up-to-$1')
            .replace(/^([\d\.]+)-inf$/g, '$1-and-above')
            .replace(/^([\d\.]+)-([\d\.]+)/g, '$1-to-$2')
            .replace(/\./g, '-');
    }
    return str.replace(/\//g, '-slash-').replace(/\s+/g, '-').replace(/\./g, '-').toLowerCase();
}
exports.transformCiToSeo = transformCiToSeo;
